import { QueryClient } from "@tanstack/react-query"

/**
 * Single shared QueryClient. Defaults are tuned for a marketing site:
 *   - staleTime 5 minutes: legal text + pricing change rarely; aggressive
 *     caching keeps repeat visits instant
 *   - retry 1: don't drown a flaky API in retries — the page always has a
 *     fallback (hardcoded pricing, "couldn't load" message)
 *   - refetchOnWindowFocus false: visitors don't context-switch like
 *     admins do, and refetching on focus on a static-feeling page is jarring
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
